export const environment = {
  production: true,
  hmr       : false,
  host: 'https://manpro.ptsiprojects.com'
};
